var map = {
	"./arrow-left.svg": 9591,
	"./arrow-right.svg": 4258,
	"./bot-icon.svg": 2795,
	"./bot.svg": 6455,
	"./chatbot-icon.svg": 1161,
	"./close.svg": 4036,
	"./error.svg": 3026,
	"./info.svg": 2892,
	"./minimize.svg": 9216,
	"./profile.svg": 4207,
	"./send.svg": 170,
	"./transactions-expenses.svg": 9171,
	"./transactions-income.svg": 9141,
	"./user-icon.svg": 4693,
	"./user.svg": 4113
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4796;